import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {GetWhatsAppIntegration as GetWhatsAppIntegrationQuery} from 'nutshell-graphql-types';

import GET_WHATSAPP_INTEGRATION from '../queries/get-whatsapp-integration.graphql';

export const useGetWhatsAppIntegration = () => {
    const {
        loading: isLoading,
        data,
        networkStatus,
        error,
        refetch,
        startPolling,
        stopPolling,
    } = useQuery<GetWhatsAppIntegrationQuery, Record<any, any>>(GET_WHATSAPP_INTEGRATION, {
        fetchPolicy: 'cache-and-network',
    });

    const {whatsAppIntegration} = makeDataDangerous(data);

    return {
        isLoading,
        isFirstLoad: isFirstLoad(networkStatus),
        whatsAppIntegration,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
        startPolling,
        stopPolling,
    };
};
